import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "./Header";
import Footer from "./Footer";
import Breadcrumbs from "./Products/Breadcrumbs";
import "./project.css";

// Images are loaded dynamically via the JSON paths
import projectsData from "./projects-data.json";

function ProjectGallery() {
  const location = useLocation();
  const [filter, setFilter] = useState("All");
  const [activeProject, setActiveProject] = useState(null);
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 900, once: true });
  }, []);

  // Map JSON paths to dynamic imports
  const projects = projectsData.map((project) => ({
    ...project,
    images: project.images.map((path) => {
      try {
        // Extract filename from path (e.g., "./image/banner-1.jpg" -> "banner-1.jpg")
        const filename = path.split("/").pop();
        return require(`./image/Project-Gallery/${filename}`);
      } catch (err) {
        console.error("Image not found:", path);
        return ""; // Fallback to empty string if not found
      }
    }),
  }));



  const filteredProjects =
    filter === "All"
      ? projects
      : projects.filter((p) => p.type === filter);

  const nextSlide = () =>
    setSlideIndex((prev) =>
      prev === activeProject.images.length - 1 ? 0 : prev + 1
    );

  const prevSlide = () =>
    setSlideIndex((prev) =>
      prev === 0 ? activeProject.images.length - 1 : prev - 1
    );

  return (

     <div className="container-fluid p-0 ">
            {location.pathname !== "/" && <Header />}
            <section className="theme-section">
                 {location.pathname !== "/" && <Breadcrumbs />}
                <div className="container" data-aos="fade-up">
                    <div className="theme-section-title text-center">
                        <h2>Our Projects</h2>
                        <p>
                          A showcase of our completed projects, crafted with precision, creativity, and quality materials. 
                          Each project reflects our commitment to thoughtful design, functional solutions, 
                          and lasting aesthetics.
                        </p>
                    </div>

                    <div className="theme-row" >
                      <div className="projects-filters">
                          {["All", "Residential", "Commercial"].map((f) => (
                      <button key={f} className={filter === f ? "active" : ""}
                        onClick={() => setFilter(f)} > {f} </button> ))}
        </div>

                    </div>

<div className="theme-row" >
      <section className="projects-grid">
        {filteredProjects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            data-aos="fade-up"
            onClick={() => {
              setActiveProject(project);
              setSlideIndex(0);
            }}
          >
            {/* Image */}
            <img src={project.images[0]} alt={project.title} />

            {/* Content BELOW image (matches your CSS) */}
            <div className="project-content">
              <h3>{project.title}</h3>
              <p>{project.shortDescription}</p>
            </div>
          </div>
        ))}
      </section>
</div>

<div className="theme-row" >
  {/* ================= POPUP SLIDER ================= */}
      {activeProject && (
        <div className="project-modal" onClick={() => setActiveProject(null)}>
          <div
            className="project-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="close-btn" onClick={() => setActiveProject(null)}>
              &times;
            </span>

            <div className="slider-main">
              <button className="nav left" onClick={prevSlide}>
                ‹
              </button>

              <img
                src={activeProject.images[slideIndex]}
                alt={activeProject.title}
              />

              <button className="nav right" onClick={nextSlide}>
                ›
              </button>

              <div className="dots">
                {activeProject.images.map((_, i) => (
                  <span
                    key={i}
                    className={i === slideIndex ? "dot active" : "dot"}
                    onClick={() => setSlideIndex(i)}
                  />
                ))}
              </div>
            </div>

            <div className="modal-info-wrap">
             
            </div>
          </div>
        </div>
      )}
</div>
                </div>
            </section>
            {location.pathname !== "/" && <Footer />}
        </div>

  );
}

export default ProjectGallery;
